import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'

export const SSTPayableReport = () => {
  const history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const { CompanyID }: any = useParams()
  const editData = location?.state as any

  const parameters = [
    {
      name: 'accountid',
      value: accountID,
    },
    {
      name: 'companyid',
      value: editData?.CompanyID,
    },
    {
      name: 'starttrxdate',
      value: new Date(editData?.StartTrxDate.setHours(0, 0, 0)).toISOString(),
    },
    {
      name: 'endtrxdate',
      value: new Date(editData?.EndTrxDate.setHours(0, 0, 0)).toISOString(),
    },
    {
      name: 'dayforunpaidinvoice',
      value: editData?.DayForUnpaidInvoice,
    },
    {
      name: 'daypaidfordueinvoice',
      value: editData?.DayPaidForDueInvoice,
    },
    {
      name: 'taxcode',
      value: editData?.TaxCode,
    },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      <MainHeader
        onClick={() =>
          history.push(
            `/digital-reports/account-receivable/sst-payable-report/parameters`
          )
        }
        mainBtn="close"
        smTitle="Account Receivable"
        title={user?.companyName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Submenu' },
          { name: 'Digital Report' },
          { name: 'SST Payable and Tracking Report', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('SSTPayableandTrackingReport', parameters),
          host: accountxReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  )
}
